import { jsxs as l, jsx as d } from "react/jsx-runtime";
import { Card as C, CardHeader as $, CardBody as n } from "@chakra-ui/react";
const y = ({
  children: e,
  bodyClassName: o,
  bodyStyleProps: s,
  "data-testid": r,
  id: a,
  title: t,
  titleClassName: i,
  titleStyleProps: m,
  ...c
}) => /* @__PURE__ */ l(C, { id: a, "data-testid": r, ...c, children: [
  t && /* @__PURE__ */ d(
    $,
    {
      className: i,
      id: a && `${a}-title`,
      "data-testid": r && `${r}-title`,
      ...m,
      children: t
    }
  ),
  /* @__PURE__ */ d(
    n,
    {
      className: o,
      id: a && `${a}-body`,
      "data-testid": r && `${r}-body`,
      ...s,
      children: e
    }
  )
] });
export {
  y as Card
};
